import React from "react";
import FAQ from "./FAQ.jsx";
import Heavymetalic from "../Images/Heavymetalic.png";
import IronRod from "../Images/IronRod.png";
import Industrialscrap from "../Images/industrialscrap.png";
import Ironpipe from "../Images/Ironpipe.png";
import MachineIronParts from "../Images/MachineIronParts.png";
import SteelScrap from "../Images/SteelScrap.png";
import SEO from "../Components/SEO";

const ironScrap = [
   {
    id: 1,
    title: "Heavy Melting Scrap (HMS)",
    image: Heavymetalic,
  },
  {
    id: 2,
    title: "Iron Rod Scrap",
    image: IronRod,
  },
  {
    id: 3,
    title: "Industrial Iron Scrap",
    image: Industrialscrap,
  },
  {
    id: 4,
    title: "Steel Scrap",
    image: SteelScrap,
  },
  {
    id: 5,
    title: "Machine Iron Parts",
    image: MachineIronParts,
  },
  {
    id: 6,
    title: "Iron Pipe Scrap",
    image: Ironpipe,
  },
];

const IronScrapSection = () => {
  return (
    <>
      <SEO 
        title="Iron Scrap Recycling & Supply" 
        description="Premium quality iron scrap including HMS (Heavy Melting Scrap), iron rods, steel scrap, machine iron parts, and iron pipes at competitive rates."
        keywords="iron scrap, Heavy Melting Scrap, HMS, iron rod scrap, steel scrap, machine iron parts, iron pipe scrap"
      />
      <style>{`
        *{
          margin:0;
          padding:0;
          box-sizing:border-box;
          font-family:Arial, Helvetica, sans-serif;
        }

        .iron-section{
          padding:70px 8%;
          background:#f5f5f5;
        }

        .heading{
          text-align:center;
          margin-bottom:50px;
        }

      .heading h2{
    color:#0A2E73;
    font-size:42px;
    font-weight:700;
}

.heading p{
    color:#666;
}

        .gallery{
          display:grid;
          grid-template-columns:repeat(auto-fit,minmax(300px,1fr));
          gap:30px;
        }

        .card{
          background:#fff;
          border-radius:15px;
          overflow:hidden;
          box-shadow:0 12px 25px rgba(0,0,0,.12);
          transition:.4s;
          cursor:pointer;
        }

        .card:hover{
    transform:translateY(-8px);
    box-shadow:0 18px 35px rgba(10,46,115,.18);
}

       .card img{
    width:100%;
    height:250px;
    object-fit:cover;
    border-bottom:4px solid #FFD700;
}

        .card:hover img{
          transform:scale(1.08);
        }

        .card-content{
          padding:20px;
        }

        .card-content h3{
    color:#0A2E73;
    font-size:28px;
    font-weight:700;
    margin-bottom:12px;
}

        .card-content p{
    color:#555;
    line-height:1.8;
    font-size:16px;
}

        .btn{
    margin-top:20px;
    display:inline-block;
    padding:12px 25px;
    background:#0A2E73;
    color:#FFD700;
    text-decoration:none;
    border-radius:30px;
    font-weight:600;
    border:2px solid #0A2E73;
    transition:.3s ease;
}

.btn:hover{
    background:#FFD700;
    color:#0A2E73;
    border-color:#FFD700;
}
        @media(max-width:768px){

          .heading h2{
            font-size:32px;
          }

          .card img{
            height:220px;
          }

        }
      `}</style>

      <section className="iron-section">

        <div className="heading">
          <h2>Iron Scrap Gallery</h2>

          <p>
            We deal in all kinds of premium quality iron scrap including
            industrial scrap, HMS, iron rods, machine parts and heavy steel
            scrap. Browse our latest collection below.
          </p>

        </div>

        <div className="gallery">

          {ironScrap.map((item)=>(
            <div className="card" key={item.id}>

              <img src={item.image} alt={item.title}/>

              <div className="card-content">

                <h3>{item.title}</h3>

                <p>
                  High quality recyclable iron scrap suitable for industrial,
                  construction and manufacturing purposes.
                </p>

                <a href="#" className="btn">
                  View Details
                </a>

              </div>

            </div>
          ))}

        </div>
      </section>
<section><FAQ/></section>
    </>
  );
};

export default IronScrapSection;